import { Component, OnInit } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import { InspectionActivityModel, InspectionRequestActivity } from 'src/app/models/activities/inspection-request-activity';


@Component({
    selector: 'wm-inspection-request-activity-view',
    templateUrl: './inspection-request-activity-view.component.html',
    styleUrls: ['./inspection-request-activity-view.component.css'],
    standalone: false
})
export class InspectionRequestActivityViewComponent extends ActivityView
  implements OnInit {
  activity: InspectionRequestActivity;
  model: InspectionActivityModel;

  constructor() {
    super();
  }

  ngOnInit() {
    this.model = new InspectionActivityModel(
      this.activity.model ? this.activity.model : null
    );
  }
}
